import GiveFeedbackWidget from './GiveFeedbackWidget'

export default GiveFeedbackWidget
